import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconPageCheck: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"page-check, signed, document"} maskId="square-filled-radius-0-stroke-1-IconPageCheck"><path d="M20 2H4V22H14.0249L11.1287 19.0714L13.2618 16.9619L15.2916 19.0144L16.5 17.5482V17.5H16.5397L20 13.3015V2Z" fill="currentColor"/><path d="M21.4538 14.6822L20.6822 14.0462L15.3591 20.5048L13.2539 18.3761L12.5429 19.0792L15.4266 21.9952L21.4538 14.6822Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconPageCheck;
